module.exports = __webpack_public_path__ + "static/cycling_plans_mobile-5e49990bb90367314ad811adee547b7b.jpg";